// Port of api/fuel/app/classes/insights/segment.php
// Base insight segment class. Each section segment extends this via Segment.extend().

import Constants from 'offline/constants'
import Util from 'offline/util'

var Segment = {}

// Create a new segment class with the given properties.
// Returns an object with the standard segment interface.
Segment.extend = function(props) {

	var segment = {

		// Static properties (defaults)
		_name: props.name || '',
		_priority: (props.priority !== undefined) ? props.priority : 1,
		_default: (props.default_ !== undefined) ? props.default_ : true,
		_enabled: (props.enabled !== undefined) ? props.enabled : true,
		_requires: props.requires || [],
		_insight: (props.insight !== undefined) ? props.insight : [],
		_detail: (props.detail !== undefined) ? props.detail : [],
		_types: props.types || [
			Constants.TYPE_USER,
			Constants.TYPE_GROUP,
			Constants.TYPE_BUDDIES
		],

		// Mutable state (reset per run by orchestrator)
		_data: {},
		_references: { games: [], users: [] },

		name: function() {
			return this._name
		},

		priority: function() {
			return this._priority
		},

		requires: function() {
			return this._requires
		},

		inject: function(data) {
			this._data = data
			this._references = { games: [], users: [] }
		},

		// Port of Segment::valid($type, $insight, $detail)
		valid: function(type, insight, detail) {
			var valid = true

			// check not disabled
			if (!this._enabled) valid = false

			// check type
			if (this._types.indexOf(type) === -1) valid = false

			// check insight
			if (insight) {
				if (this._insight === false || (insight !== this.name() && (!Array.isArray(this._insight) || this._insight.indexOf(insight) === -1))) {
					valid = false
				}
			}
			// check detail
			else if (detail) {
				if (this._detail === false || (detail !== this.name() && (!Array.isArray(this._detail) || this._detail.indexOf(detail) === -1))) {
					valid = false
				}
			}
			// check can be run by default
			else if (!this._default) {
				valid = false
			}

			return valid
		},

		run: function(type, owner, userIndex, detail, filter, vars) {
			if (props.run) return props.run.call(this, type, owner, userIndex, detail, filter, vars)
			return {}
		},

		data: function() {
			return this._data
		},

		references: function() {
			return this._references
		}

	}

	// Port of Segment::isSelf($player, $user_id, $username)
	segment.isSelf = function(player, user_id, username) {
		var playerUserId = parseInt(player.user_id, 10) || 0

		if (playerUserId === user_id) return true

		var playerUsername = player.player_username

		if (playerUsername && playerUsername.toLowerCase() === username) return true

		if (!playerUserId && !playerUsername) {
			var playerName = player.player_name
			if (playerName && playerName.toLowerCase() === username) return true
		}

		return false
	}

	// Port of Segment::get_period_date_range($type, $owner, $filter)
	segment.get_period_date_range = function(type, owner, filter) {
		var range = {}
		var currentDate = Math.floor(Date.now() / 1000)
		var firstDate = owner.get_date_play_first ? owner.get_date_play_first() : currentDate

		if (filter.period === 'current') {
			range.start = Util.week_start(currentDate) - (Constants.TIME_WEEK * 52)
			range.end = Util.date_end(currentDate)
		} else if (filter.period === 'all') {
			range.start = Util.week_start(firstDate)
			range.end = Util.date_end(currentDate)
		} else if (filter.period) {
			var year = parseInt(filter.period, 10)
			range.start = Util.mktime(0, 0, 0, [1, 1, year])
			range.end = Util.mktime(0, 0, 0, [1, 1, year + 1]) - 1

			var endOfDay = Util.date_end(currentDate)
			if (range.end > endOfDay) range.end = endOfDay
		} else {
			range.start = Util.week_start(currentDate) - (Constants.TIME_WEEK * 52)
			range.end = Util.date_end(currentDate)
		}

		return range
	}

	// Copy any additional static methods from props
	if (props.methods) {
		var keys = Object.keys(props.methods)
		for (var i = 0; i < keys.length; i++) {
			segment[keys[i]] = props.methods[keys[i]]
		}
	}

	return segment
}

export default Segment
